import {GET_CHALLENGE} from "../../../graphql/challenge";
import { client } from '../../utilities/config';

  export const getChallenge = () => {
    return client.query({
      fetchPolicy: "no-cache",
      query: GET_CHALLENGE
    });
  };
